////////////// JQUERY CONFLICT NO PLEASE

(function ($) {

    ///////////////////////////////////
    ///////     FUNCTIONS     /////////
    ///////////////////////////////////

    window.initializeMap = window.initializeMap || function(div, gmap_config) {
        if (typeof(div) === "undefined") div = "map_canvas";

        // general vars
        var center;
        var marker_icon;
        window.visible_markers = [];
        // var bounds = new google.maps.LatLngBounds();
        var drag  =  (jQuery(window).width()>767) ? gmap_config.map_drag : false ;


        if (typeof(map_marker)!=='undefined' && map_marker!=null) {
            // center map is the hotel coords
            center = new google.maps.LatLng(map_marker.lat, map_marker.lng);
        }
        //
        var myOptions = {
            //map type
            mapTypeId: google.maps.MapTypeId[gmap_config.maptype.toUpperCase()],
            mapTypeControl: gmap_config.map_type_control,
            mapTypeControlOptions: {
                position: google.maps.ControlPosition[gmap_config.map_type_position]
            },
            // position
            center: center,
            //zoom
            zoom: gmap_config.map_zoom,
            zoomControl: gmap_config.map_zoom_control,
            zoomControlOptions: {
                position: google.maps.ControlPosition[gmap_config.zoom_control_position]
            },
            // scroll wheel
            scrollwheel: gmap_config.scrollwheel,

            // default pan control
            panControl: false,
            // scale control - image with the scale index (m,km,etc)
            scaleControl: false,
            // 	streetview controls
            streetViewControl: gmap_config.street_view_enable,
            streetViewControlOptions: {
                position: google.maps.ControlPosition[gmap_config.streetview_position]
            },
            // draggable for mobile
            draggable: drag
        };

        // do map!
        var map = new google.maps.Map(document.getElementById(div), myOptions);
        // i need in the cloud
        window.map = map;
        // window.centermap = center;


        // hotel marker
        if(typeof map_marker !== 'undefined' && map_marker != null) {
            marker_icon = (typeof map_marker.marker !=='undefined' && map_marker.marker !=='') ? map_marker.marker : theme_dir+'/images/marker.png';
            var marker = new google.maps.Marker({
                position			:	new google.maps.LatLng(map_marker.lat, map_marker.lng),
                map					:	map,
                title				:	map_marker.title,
                // icon : {
                //     url: marker_icon ,
                    // size: new google.maps.Size(71, 93) ,
                    // anchor: new google.maps.Point(30, 81)
                // }
            });

            var map_marker_infowindow = new google.maps.InfoWindow({
                content				: map_marker.html
            });
            window.map_marker_infowindow = map_marker_infowindow;
            google.maps.event.addListener(marker, 'click', (function(marker) {
                return function() {
                    if(window.prev_infowindow){
                        window.prev_infowindow.close();
                    }
                    window.prev_infowindow = map_marker_infowindow;
                    window.map_marker_infowindow.open(map, this);
                }
            })(marker));
        }

        // onresize
        google.maps.event.addListenerOnce(window, "resize", function () {
            var center = map.getCenter();
            google.maps.event.trigger(map, "resize");
            map.setCenter(center);
        });
        // // when the maps is ready
        // google.maps.event.addListenerOnce(map, "idle", function () {
        //     // all pois active
        //     setTimeout(function(){
        //         show_map_category('all');
        //     },500);
        //     map_height();
        // });
    };
})(jQuery);